import React, { useState } from 'react'
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from '@mui/material'
import { usePartnerAffiliateUserRejectMutation } from '~/graphql/types'
import { toast } from 'react-toastify'

type RejectModalProps = {
  open: boolean
  onClose: () => void
  userId: string
  onSuccess: () => void
}

export const RejectModal: React.FC<RejectModalProps> = ({ open, onClose, userId, onSuccess }) => {
  const [justification, setJustification] = useState('')
  const [error, setError] = useState('')

  const [rejectUser, { loading }] = usePartnerAffiliateUserRejectMutation({
    onCompleted() {
      toast.success('Preposto reprovado com sucesso!')
      onSuccess()
      onClose()
      setJustification('')
      setError('')
    },
    onError(err) {
      toast.error(err.message)
    }
  })

  const handleConfirm = () => {
    if (!justification.trim()) {
      setError('A justificativa é obrigatória.')
      return
    }
    rejectUser({ variables: { id: userId, justification: justification.trim() } })
  }

  const handleClose = () => {
    if (loading) return
    setJustification('')
    setError('')
    onClose()
  }

  return (
    <Dialog open={open} onClose={handleClose} maxWidth='sm' fullWidth>
      <DialogTitle>
        <Typography fontWeight={600} variant='h5'>Reprovar preposto</Typography>
      </DialogTitle>
      <DialogContent>
        <Typography color='text.secondary' sx={{ mb: 2 }}>
          Informe o motivo da reprovação. Esta justificativa ficará registrada no histórico.
        </Typography>
        <TextField
          fullWidth
          multiline
          rows={4}
          variant='outlined'
          label='Justificativa'
          value={justification}
          onChange={(e) => {
            setJustification(e.target.value)
            if (e.target.value.trim()) setError('')
          }}
          error={Boolean(error)}
          helperText={error}
          placeholder='Descreva o motivo da reprovação...'
          sx={{
            mt: 1,
            '& .MuiInputBase-root': {
              padding: '12px',
            },
          }}
        />
      </DialogContent>
      <DialogActions sx={{ padding: '1rem 1.5rem' }}>
        <Button color='secondary' onClick={handleClose} disabled={loading}>
          Cancelar
        </Button>
        <Button
          color='error'
          variant='contained'
          onClick={handleConfirm}
          disabled={loading}
          endIcon={loading ? <CircularProgress size={18} color='inherit' /> : null}
        >
          Reprovar
        </Button>
      </DialogActions>
    </Dialog>
  )
}
